import { useRegionTreeSelect } from "../RegionTreeSelectContext";

import type { CountryCode } from "models/CountryCode";
import type { SelectedCountry } from "../types";

export function useCountryItem() {
  const { selectedCountries, onUpdate } = useRegionTreeSelect();

  const isCountrySelected = (code: CountryCode) =>
    selectedCountries.some(({ id }) => id === code);

  const handleToggleCountry = (country: SelectedCountry) => () => {
    const newSelectedCountries = isCountrySelected(country.id)
      ? selectedCountries.filter(({ id }) => id !== country.id)
      : [...selectedCountries, country];

    onUpdate(newSelectedCountries);
  };

  return {
    isCountrySelected,
    handleToggleCountry,
  };
}
